export const translateScores = (competence: number, scoreType: number): string => {
  const scoreTable = [
    { score: 5, label: '1.00', type: 1 },
    { score: 10, label: '2.00', type: 1 },
    { score: 15, label: '3.00', type: 1 },
    { score: 3.4, label: '1.00', type: 2 },
    { score: 6.7, label: '2.00', type: 2 }, 
    { score: 10, label: '3.00', type: 2 },
    { score: 4, label: '1.00', type: 3 },
    { score: 8.2, label: '2.00', type: 3 },
    { score: 12.5, label: '3.00', type: 3 }
  ];

  const score =
    competence === 4 || competence === 8.2 || competence === 12.5
      ? scoreTable.find(score => score.score === competence)
      : scoreTable.find(score => score.score === competence && score.type === scoreType);

  return score ? score.label : '';
}